module.exports = __webpack_public_path__ + "img/sidebar-3.df151f8f.jpg";